module.exports = __webpack_public_path__ + "img/icon_personalizacao_dados_comunicacao.e5ea6e28.svg";